__turbopack_context__.v({
  "circled-chevron-up-icon": "CircledChevronUp-module-scss-module__4rRFOG__circled-chevron-up-icon",
});
